export default {
  continueAs: '继续作为',
  individual: '个人',
  corporate: '企业',
  agreeTermsIntro: '选择测试版本选项之一，即表示您同意我们的',
  agreeTerms: '我同意',
  and: '和',
  privacyPolicy: '隐私政策',
  termsCondition: '条款和条件',
  priadi: 'PRiADI',
  welcome: '欢迎来到 @:priadi',
  loginPageSubtitle: '使用您的 @:email 和 @:password',
  email: '电子邮件',
  emailHint: '输入您的电子邮件地址',
  password: '密码',
  passwordHint: '输入您的密码',
  fullname: '姓名',
  fullnameHint: '输入您的全名',
  rePassword: '确认密码',
  rePasswordHint: '再次输入您的密码',
  phone: '电话号码',
  phoneHint: '输入您的电话号码',
  birthdate: '出生日期',
  birthdateHint: '输入您的出生日期',
  signup: '报名',
  signin: '登入',
  signout: '登出',
  signupText: '要创建帐户，请填写下面的表格',
  noaccount: '没有账户？',
  hasAccount: '已有帐户？',
  greeting: '您好',
  sloganHome: '释放您的真正潜力：',
  sloganHomeSubtitle: '用PRiADI心理指纹发现自我',
  testPackage: '测试包',
  promo: '推荐码/促销活动',
  freeConsult: '免费咨询',
  noConsult: '未经协商',
  submit: '提交',
  contactUs: '联系我们',
  callCenter: '呼叫中心',
  voucherCodeText: '在下面的栏目中输入促销代码即可获得特价',
  voucherCodeHint: '在此处插入促销/优惠券代码',
  invalidReferralCode: '无效的推荐码。请检查您的推荐码。',
  validReferralCode: '推荐码已接受！您可获得折扣。',
  referralCodeError: '推荐码无法提供任何折扣。',
  codeApplied: '优惠码已成功应用！',
  codeInvalid: '优惠码无效或无法识别。',
  features: '特征',
  includeConsultation: '包括咨询会议',
  selectPackage: '选择套餐',
  selectCounselor: '选择辅导员',
  selectedCounselor: '选定的辅导员',
  consultationType: '咨询类型',
  counselorName: '辅导员姓名',
  counselorFee: '咨询费用',
  contactAvailability: '请联系呼叫中心了解可用性',
  free: '免费',
  selectCounselorFirst: '请先选择辅导员',
  cancel: '取消',
  total: '全部的',
  continue: '继续',
  online: '在线的',
  offline: '离线',
  note: '笔记',
  satisfiedClient: '位满意客户',
  edit: '改变',
  success: '成功',
  redirectLogin: '重定向到登录页面',
  validation: {
    required: '{field} 不能为空。',
    minLength: '{field} 必须至少包含 {min} 个字符。',
    passwordMismatch: '密码不匹配。',
    minLowercase: '{field} 必须至少包含 {min} 个小写字符',
    minUppercase: '{field} 必须至少包含 {min} 个大写字符',
    minNumeric: '{field} 必须至少包含 {min} 个数字',
    minSymbol: '{field} 必须至少包含 {min} 个符号',
  },
  transaction: '交易',
  testResult: '测试结果',
  testResultMsg: {
    empty: '没有可用的测试结果',
    email: '测试结果将通过电子邮件发送',
    corporate: '请联系评估负责人了解测试结果',
  },
  validUntil: '有效期至',
  takeATest: '参加测试',
  checkout: '查看',
  testDone: '完毕',
  checkoutQuestion: '您确定要结帐吗？',
  checkoutFailed: '结账时发生错误',
  confirmation: {
    title: '确认',
    prompt: '你确定吗？{optional}',
    yes: '是的',
    no: '不',
    cancel: '取消',
    back: '后退',
  },
  testMethod: '测试方法',
  chooseOne: '选择一个',
  liveCapture: {
    title: '捕获手指',
    subtitle: '直接用手机摄像头拍摄你的10个手指的照片',
  },
  uploadFinger: {
    title: '上传手指图像',
    subtitle: '将您的十个手指的照片上传到提供的表格中。',
    tutorialTitle: '在我们继续之前',
    tutorialSubtitle: '请仔细阅读以下说明',
    retake: '你想重考嗎？',
    retakeTitle: '重拍',
    retakeConfirm: '是的，重考',
    retakeCancel: '否，保留当前图片',
    finish: '结束',
    leftHand: '左手',
    rightHand: '右手',
    continuePayment: '继续付款',
    continueTransaction: '返回交易列表',
    continueTakeAnother: '再做一次测试',
  },
  isRecommended: '非常适合大多数用户',
  bottomNav: {
    home: '首页',
    transaction: '交易',
    profile: '剖面',
    callCenter: '呼叫中心',
  },
  changePassword: {
    title: '更改密码',
    newPassword: '新密码',
    oldPassword: '旧密码',
  },
  externalLink: {
    prompt: '这将带您到外部链接',
  },
  createTransaction: {
    title: '创建交易',
    subtitle: '填写下面的表格以继续',
  },
  reset: '重置',
  saved: '已保存',
  failed: '失败的',
  noTransaction: '目前还没有任何交易记录。',
  guessModalText: '为了获得最佳体验，请登录。或者，您可以继续以访客身份访问。',
  continueAsGuest: '以访客身份继续',
  or: '或',
  capture: {
    beforeProceeding: '在继续之前，',
    watchTutorial: '请仔细观看下面的教程：',
    pleasWait: '请稍候',
    seconds: '秒',
    takeFinger: '拍摄指纹',
    finish: '完成',
    fingerGuide: '指纹拍摄指南',
    continue: '继续',
  },
  payment: {
    title: '支付确认',
    amountToPay: '应支付金额：',
    bankInfo: 'BNI 353664685 户名：Dedi Priadi',
    uploadProof: '*请上传转账凭证，以便您的数据能够立即处理。',
    uploadButton: '上传转账凭证',
    importantInfo: '重要信息',
    paymentInstructions: [
      '根据上面显示的金额支付至列出的账户',
      '支付必须在进行测试后最迟 2（两）天内完成',
      '测试结果将在支付后最迟 3（三）个工作日内通过交易中登记的电子邮件发送',
      '如果支付日期超过规定期限，交易将被取消',
    ],
    uploadModalTitle: '上传转账凭证',
    cancel: '取消',
    upload: '上传',
  },
  paymentPrompt: {
    proceedToPayment: '继续支付？',
    yes: '是',
    no: '否',
  },
  paymentCheckout: {
    title: '支付结账',
    saved: '交易已保存',
    clickToPayment: '点击下方继续付款',
    processPayment: '处理支付',
  },
  paymentSuccess: {
    title: '付款成功！',
    message: '您的付款已成功处理。您将在几个工作日内通过电子邮件收到测试结果。',
    backToTransactions: '返回交易',
  },
  paymentFailed: {
    title: '付款失败',
    message: '您的付款未成功。请重试或联系',
    customerService: '我们的客户服务',
    backToTransactions: '返回交易',
  },
  paymentUnfinished: {
    title: '付款待处理',
    message: '您的付款仍在处理中。请立即完成付款，以便我们可以处理您的测试。',
    backToTransactions: '返回交易',
  },
  sessionExpired: '会话已过期',
  sessionExpiredDesc: '您的会话已过期。请重新登录。',
  register: {
    title: '创建账户',
    step1Subtitle: '创建您的账户以开始评估',
    step2Subtitle: '设置您的登录凭据',
  },
  loginModal: {
    title: '欢迎来到 PRiADI',
    subtitle: '为了获得最佳体验，请登录或注册。您也可以继续以访客身份浏览。',
  },
  months: {
    '01': '一月',
    '02': '二月',
    '03': '三月',
    '04': '四月',
    '05': '五月',
    '06': '六月',
    '07': '七月',
    '08': '八月',
    '09': '九月',
    10: '十月',
    11: '十一月',
    12: '十二月',
  },
}
